@if (hasPublishedItems()) {
<rds-divider class="divider"></rds-divider>
<div class="accordion-item faq">
  <h1 class="ui-heading-1-bold faq-title">{{ knowledgeSection() }}</h1>
  <ul class="faq-content">
    @for(f of faq(); track $index) {
      @if(f.published === true) {
      <li class="faq-item">
        <rds-accordion multi>
          <rds-expansion-panel togglePosition="after">
            <rds-expansion-panel-header>
              <rds-panel-title>
                <h3 class="ui-heading-3">{{ f.question }}</h3>
              </rds-panel-title>
            </rds-expansion-panel-header>

            <p class="ui-body-m" [innerText]="f.answer"></p>
          </rds-expansion-panel>
        </rds-accordion>
      </li>
      }
    }
  </ul>
</div>
}
